import { GET_PLC_SAFETY_TRIGGERS, GET_PLC_SAFETY_TRIGGERS_SUCCESS, GET_PLC_SAFETY_TRIGGERS_ERROR } from './actionTypes';

const initialState = {
  errorGetPlcSafetyTriggers: '',
  loadingGetPlcSafetyTriggers: false,
  triggers: null,
};

const getTriggers = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLC_SAFETY_TRIGGERS:
      state = { ...state, loadingGetPlcSafetyTriggers: true };
      break;
    case GET_PLC_SAFETY_TRIGGERS_SUCCESS:
      state = { ...state, loadingGetPlcSafetyTriggers: false, triggers: action.payload.triggers };
      break;
    case GET_PLC_SAFETY_TRIGGERS_ERROR:
      state = { ...state, errorGetPlcSafetyTriggers: action.payload, loadingGetPlcSafetyTriggers: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getTriggers;
